<template>
    <div class="authorization-overview-container">
        <div class="top">
            <label class="ticket-nr" v-if="contract.contractNr > 0">{{ $t('general.ticket-nr') }} {{ contract.contractNr }}</label>
            <label class="ticket-nr" v-if="contract.contractNr <= 0">{{ $t('general.ticket-not-issued') }}</label>
            <label class="termination-date" v-if="contract.terminationDate" >{{ $t('general.terminated-on', [contract.terminationDate]) }}</label>
        </div>
        <div class="mid">
            <div class="left">
                <div class="temporal-validity" v-if="contract.validFrom || contract.validUntil">
                    <label class="label" v-if="contract.validFrom">{{ $t('general.valid-from') }}</label>
                    <label class="value" v-if="contract.validFrom">{{ contract.validFrom }}</label>
                    <br />
                    <label class="label" v-if="contract.validUntil">{{ $t('general.valid-until') }}</label>
                    <label class="value" v-if="contract.validUntil">{{ contract.validUntil }}</label>
                </div>
                <div class="spatial-validity" v-if="contract.fromLocation || contract.toLocation">
                    <label class="label" v-if="contract.fromLocation">{{ $t('general.valid-from-location') }}</label>
                    <label class="value" v-if="contract.fromLocation">{{ contract.fromLocation }}</label>
                    <br />
                    <label class="label" v-if="contract.toLocation">{{ $t('general.valid-to-location') }}</label>
                    <label class="value" v-if="contract.toLocation">{{ contract.toLocation }}</label>
                </div>
            </div>
            <div class="right">
                <label class="price">{{ util.formatCurrency(contract.priceToPay) }} €</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'authorization-overview',
    inject: [ 'util' ],
    props: {
        contract: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.authorization-overview-container {
    width: 100%;
    height: 100%;

    > .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    > .mid {
        width: 100%;
        margin-top: 20px;
        display: flex;

        > .left {
            flex: 1;
        }

        > .right {
            width: 165px;
        }
    }
}

.top {
    > .termination-date {
        font-size: 1.25em;
        color: red;
        font-weight: bold;
    }
}

.mid {
    > .left {
        display: flex;
        flex-direction: column;

        // > .ticket-nr {
        //     color: #999;
        // }

        > label {
            margin-top: 8px;
            // font-weight: bold;
            
            &:first-of-type {
                margin-top: 0;
            }
        }

        > .spatial-validity,
        > .temporal-validity {
            > .label {
                display: inline-block;
                width: 60px;
                // text-align: right;
                color: #666;
            }

            > .value {
                margin-left: 12px;
                font-size: 1.25em;
            }

            &.spatial-validity {
                margin-top: 12px;
            }
        }
    }

    > .right {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;

        > .price {
            font-weight: bold;
            font-size: 3em;
        }
    }
}
</style>